module.exports = __webpack_public_path__ + "img/viewPointMapIcon_selecting_circle.c20df0a5.png";